import * as system from 'durandal/system';

import * as userService from '@/legacy/services/user';
import * as plootoUtils from '@/legacy/utils/plooto';

import BankLoginSource from '../bankLoginSource';

const API_PREFIX = 'v1';

export class SecondaryBankPollAccountDetailsBindingModel {
  public loginId: string;

  public accountId: string;

  public requestId: string;

  public country: string;

  public relatedId: string;

  public bankLoginSource: BankLoginSource;
}

export class SecondaryBankPollResponse {
  public account: SecondaryBankValidBankAccountViewModel;

  public statusCode: number;

  public requestId: string;
}

export class SecondaryBankValidBankAccountViewModel {
  accountOperatingName: string;

  hasAccountHolderName: boolean;

  isBankingDetailsValid: boolean;

  maskedAccountNumber: string;

  currency: string;

  country: string;
}

export interface GetAuthorizationKeyBindingModel {
  country: string;
  bankLoginSource: BankLoginSource;
  relatedId: string;
}

export class SecondaryBankLoginService {
  private userService: userService.UserService;

  constructor() {
    this.userService = userService.Instance;
  }

  public pollSecondaryBankAccountDetails(
    model: SecondaryBankPollAccountDetailsBindingModel
  ): JQueryPromise<SecondaryBankPollResponse> {
    return system
      .defer<SecondaryBankPollResponse>((dfd) => {
        this.userService
          .AuthorizedPost(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/bankLogin/payee/secondaryBank/pollAccountDetails`,
            model
          )
          .done((secondaryBankPollResponse) => {
            if (
              plootoUtils.IsNullOrUndefined(secondaryBankPollResponse) ||
              secondaryBankPollResponse.error === true
            ) {
              dfd.reject(secondaryBankPollResponse);
              return;
            }

            dfd.resolve(secondaryBankPollResponse);
          })
          .fail((err) => {
            dfd.reject(err);
          });
      })
      .promise();
  }

  public getAuthorizationKey(
    model: GetAuthorizationKeyBindingModel
  ): JQueryPromise<SecondaryBankPollResponse> {
    return system
      .defer<SecondaryBankPollResponse>((dfd) => {
        this.userService
          .AuthorizedGetFromUri(
            `${
              import.meta.env.APP_URLS_API_URL
            }/${API_PREFIX}/bankLogin/payee/secondaryBank/authorizationKey`,
            model
          )
          .done((data) => {
            if (plootoUtils.IsNullOrUndefined(data) || data.error === true) {
              dfd.reject(data);
              return;
            }

            dfd.resolve(data);
          })
          .fail((err) => {
            dfd.reject(err);
          });
      })
      .promise();
  }
}

export const Instance = new SecondaryBankLoginService();
